import { Card } from "@/components/ui/card";
import { inr, inrShort } from "@/lib/api";
import { HardHat } from "lucide-react";

const MILESTONES = [
  { name: "Booking, Design & Approvals", pct: 5, color: "#64748B" },
  { name: "Foundation & Plinth", pct: 15, color: "#F97316" },
  { name: "RCC Superstructure", pct: 30, color: "#F59E0B" },
  { name: "Brickwork & Roofing", pct: 15, color: "#FBBF24" },
  { name: "Plastering & Flooring", pct: 15, color: "#10B981" },
  { name: "Electrical & Plumbing", pct: 10, color: "#3B82F6" },
  { name: "Finishing, Painting & Handover", pct: 10, color: "#8B5CF6" },
];

export const Milestones = ({ result }) => {
  if (!result) return null;
  const total = result.total_cost;
  let cumulative = 0;

  return (
    <Card className="bg-slate-900/70 border-slate-800 rounded-2xl p-6 sm:p-8" data-testid="milestones">
      <div className="flex items-center gap-3 mb-6">
        <div className="h-10 w-10 rounded-xl bg-amber-500/15 grid place-items-center">
          <HardHat className="h-5 w-5 text-amber-400" />
        </div>
        <div>
          <h3 className="font-heading text-xl font-bold text-white">Stage-wise Payment Plan</h3>
          <p className="text-sm text-slate-400">
            Break the ₹{inr(total)} budget into construction milestones
          </p>
        </div>
      </div>

      {/* Cumulative bar */}
      <div className="flex h-3 w-full overflow-hidden rounded-full mb-6">
        {MILESTONES.map((m, i) => (
          <div key={i} style={{ width: `${m.pct}%`, background: m.color }} title={`${m.name} ${m.pct}%`} />
        ))}
      </div>

      <div className="space-y-3">
        {MILESTONES.map((m, i) => {
          cumulative += m.pct;
          const amount = Math.round((total * m.pct) / 100);
          return (
            <div
              key={i}
              data-testid={`milestone-${i}`}
              className="flex items-center gap-4 rounded-xl border border-slate-800 bg-slate-950/60 p-4 hover:border-orange-500/40 transition-colors"
            >
              <div
                className="h-9 w-9 shrink-0 rounded-lg grid place-items-center font-heading font-bold text-white text-sm"
                style={{ background: m.color }}
              >
                {i + 1}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-semibold text-white truncate">{m.name}</p>
                <p className="text-xs text-slate-500 font-mono-data">
                  {m.pct}% · cumulative {cumulative}%
                </p>
              </div>
              <div className="text-right">
                <p className="font-mono-data font-bold text-white">₹{inr(amount)}</p>
                <p className="text-xs text-slate-500">{inrShort(amount)}</p>
              </div>
            </div>
          );
        })}
      </div>

      <p className="text-xs text-slate-500 mt-4">
        * Indicative payment milestones commonly used for independent house construction in India.
        Agree the exact schedule with your contractor before starting work.
      </p>
    </Card>
  );
};
